import { DialogContent } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const StyledDialogContent = styled(DialogContent) `
  overflow: hidden;
`;
